<template>
  <vs-popup id="popupRiskInfo3_3x3" :title="$t('위험성평가 기준표')" :active.sync="popupActiveSync">
    <div class="p-4 grid" style="grid-template-columns: 545px 1fr; gap: 0.5rem;">
      <table cellspacing="0">
        <tr>
          <th colspan="2" rowspan="2">{{ $t('구분') }}</th>
          <th colspan="3">{{ $t('중대성(강도)') }}</th>
        </tr>
        <tr>
          <th>3</th>
          <th>2</th>
          <th>1</th>
        </tr>
        <tr>
          <th rowspan="3">{{ $t('가능성') }}<br>({{ $t('빈도') }})</th>
          <th>3</th>
          <td class="error">{{ $t('9(높음)') }}</td>
          <td class="error">{{ $t('6(높음)') }}</td>
          <td class="warning">{{ $t('3(보통)') }}</td>
        </tr>
        <tr>
          <th>2</th>
          <td class="error">{{ $t('6(높음)') }}</td>
          <td class="warning">{{ $t('4(보통)') }}</td>
          <td class="success">{{ $t('2(낮음)') }}</td>
        </tr>
        <tr>
          <th>1</th>
          <td class="warning">{{ $t('3(보통)') }}</td>
          <td class="success">{{ $t('2(낮음)') }}</td>
          <td class="success">{{ $t('1(낮음)') }}</td>
        </tr>
      </table>
      <table cellspacing="0">
        <tr style="height: 100px;">
          <th >{{ $t('위험성수준') }}</th>
          <th >{{ $t('관리기준') }}</th>
          <th >{{ $t('내용') }}</th>
        </tr>
        <tr>
          <th class="error">{{ $t('6~9(높음)') }}</th>
          <th>{{ $t('즉시개선') }}</th>
          <td class="text-left">{{ $t('작업을 지속하려면 즉시 개선이 필요한 상태') }}</td>
        </tr>
        <tr>
          <th class="warning">{{ $t('3~4(보통)') }}</th>
          <th>{{ $t('개선') }}</th>
          <td class="text-left">{{ $t('안전보건대책을 수립하여 개선이 필요한 상태') }}</td>
        </tr>
        <tr>
          <th class="success">{{ $t('1~2(낮음)') }}</th>
          <th>{{ $t('현상유지') }}</th>
          <td class="text-left">{{ $t('근로자에게 유해·위험 정보제공 및 교육 등이 필요한 상태') }}</td>
        </tr>
      </table>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'PopupRiskInfo_3x3_3',
  props: {
    value: Boolean,
  },
  components: {
  },
  computed: {
    popupActiveSync: {
      get () {
        return this.value
      },
      set () {
        this.handleCloseSelf()
      }
    }
  },
  methods: {
    handleCloseSelf () {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.risk-info-body {
  display: grid;
  grid-template-columns: 228px 228px 228px 228px 228px;
  span {
    padding: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #DEDEDE;

    &.left {
      justify-content: flex-start;
    }
  }
}
.risk-info-header {
  display: grid;
  grid-template-columns: 228px 228px 228px 228px 228px;
  grid-template-areas: "A A A A A" "B C D E F";
  grid-template-rows: 40px 50px;
  background-color: #F9F9F9;
  span {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #DEDEDE;
  }
}
.risk-info-header-second {
  display: grid;
  grid-template-columns: 327px 812px;
  background-color: #F9F9F9;
  span {
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #DEDEDE;
  }
}
.risk-info-body-second {
  display: grid;
  grid-template-columns: 163px 164px 812px;
  span {
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #DEDEDE;

    &.left {
      justify-content: flex-start;
    }
  }
}
</style>
<style>

#popupRiskInfo3_3x3 > .vs-popup {
  width: 1173px !important;
}

#popupRiskInfo3_3x3 > .vs-popup > .vs-popup--content {
  width: 100%;
  padding: 0;
  margin: 0;
}

#popupRiskInfo3_3x3 > .vs-popup > .vs-popup--content > .vs-row {
  padding: 24px;

}

</style>



<style lang="scss" scoped>
table {
  width: 100% !important;
  text-align: center;
  border-top: 1px solid #DEDEDE;
  border-left: 1px solid #DEDEDE;
}
th, td {
  border-right: 1px solid #DEDEDE;
  border-bottom: 1px solid #DEDEDE;
  font-size: 1.0rem;
  text-align: center;
  padding: 1rem;
}

.error { background: #F08182 !important; }
.warning { background: #FFB976 !important; }
.success { background: #48DA89 !important; }


</style>
